import React, { Suspense } from "react";
import {
    BrowserRouter as Router,
    Route,
    Navigate,
    Routes
} from "react-router-dom";

import MainNavigation from "./shared/components/Navigation/MainNavigation";
import { AuthContext } from "./shared/context/auth-context";
import { AppConfigContext } from "./shared/context/appconfig-context";
import { useAuth } from "./shared/hooks/auth-hook";
import { useAppConfig } from "./shared/hooks/appconfig-hook";
import LoadingSpinner from "./shared/components/UIElements/LoadingSpinner";

// Lazy loading components
const Landing = React.lazy(() => import("./landing/pages/Landing"));
const User = React.lazy(() => import("./user/pages/User"));
const NewExpense = React.lazy(() => import("./expenses/pages/NewExpense"));
const Dashboard = React.lazy(() => import("./expenses/pages/Dashboard"));
const UserExpenses = React.lazy(() => import("./expenses/pages/UserExpenses"));
const UpdateExpense = React.lazy(() =>
    import("./expenses/pages/UpdateExpense")
);
const Auth = React.lazy(() => import("./user/pages/Auth"));
const ForgotPassword = React.lazy(() => import("./user/pages/ForgotPassword"));

const App = () => {
    const {
        userId,
        userEmail,
        isTestUser,
        categories,
        updateCategories,
        token,
        login,
        logout,
        userLanguage,
        changeUserLanguage,
    } = useAuth();
    const {
        language,
        changeLanguage,
        acceptedLanguages,
        isFirstHomePageLoad,
        onFirstHomePageLoad,
    } = useAppConfig();

    let routes;

    if (token) {
        routes = (
            <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/userprofile" element={<User />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/myexpenses" element={<UserExpenses />} />
                <Route path="/expenses/new" element={<NewExpense />} />
                <Route path="/expenses/:expenseId" element={<UpdateExpense />} />
                <Route path="/auth" element={<Auth />} />
                {/* <Redirect to="/" /> */}
                <Route path="/*" element={<Navigate replace to="/" />} />
            </Routes>
        );
    } else {
        routes = (
            <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/auth" element={<Auth />} />
                {/* <Redirect to="/" /> */}
                <Route path="/*" element={<Navigate replace to="/" />} />
            </Routes>
        );
    }

    return (
        <AuthContext.Provider
            value={{
                isLoggedIn: !!token,
                token: token,
                userId: userId,
                userEmail: userEmail,
                isTestUser: isTestUser,
                categories: categories,
                userLanguage: userLanguage,
                changeUserLanguage: changeUserLanguage,
                login: login,
                logout: logout,
                updateCategories: updateCategories,
            }}>
            <AppConfigContext.Provider
                value={{
                    language: language,
                    changeLanguage: changeLanguage,
                    acceptedLanguages: acceptedLanguages,
                    isFirstHomePageLoad: isFirstHomePageLoad,
                    onFirstHomePageLoad: onFirstHomePageLoad,
                }}>
                <Router>
                    <MainNavigation />
                    <main>
                        <Suspense
                            fallback={
                                <div className="center">
                                    <LoadingSpinner />
                                </div>
                            }>
                            {routes}
                        </Suspense>
                    </main>
                </Router>
            </AppConfigContext.Provider>
        </AuthContext.Provider>
    );
};

export default App;
